import * as React from "react";
import SelectTagModal, {
  SelectTagsFor,
} from "../../../../../components/molecules/SelectTagModal/index";
import StudentTag from "../../../../../domains/StudentTag";
import { ActiveOperator } from "../../../../../interfaces/SectionOperatorsInterface";
import ToggleButton from "./ToggleButton";

interface Props {
  sectionId: string;
  operator: ActiveOperator;
  sectionTags: StudentTag[];
  isPending: boolean;
  onTagsChange: (tagIds: string[], onSuccess: () => void) => void;
}

const OperatorTagSwitch: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleToggle = () => {
    setIsOpen(true);
  };

  const handleModalClose = () => {
    setIsOpen(false);
  };

  const handleClick = (selectedTags: { id: string }[]) => {
    if (props.isPending) {
      return;
    } else {
      props.onTagsChange(
        selectedTags.map((tag) => tag.id),
        () => setIsOpen(false),
      );
    }
  };

  return (
    <React.Fragment>
      <ToggleButton
        isLimited={props.operator.isLimited}
        onClick={handleToggle}
      />
      <SelectTagModal
        submitting={props.isPending}
        selectTagsFor={SelectTagsFor.Operator}
        sectionTags={props.sectionTags}
        selectedTags={props.operator.tags}
        isOpen={isOpen}
        onRequestClose={handleModalClose}
        onSubmit={handleClick}
      >
        <h2>{props.operator.fullName}の閲覧制限タグ設定</h2>
      </SelectTagModal>
    </React.Fragment>
  );
};

export default OperatorTagSwitch;
